// Pure SMS/car-data helpers shared by the SMS board. Kept framework-free so they
// can be unit-tested in isolation.

// Builds the visible SMS prefix: "Company, Phone: message" (skips empty parts).
export function composeSms(companyName, contactPhone, message) {
  const parts = [];
  if (companyName && companyName.trim()) parts.push(companyName.trim());
  if (contactPhone && contactPhone.trim()) parts.push(contactPhone.trim());
  const prefix = parts.join(', ');
  return prefix ? `${prefix}: ${message}` : message;
}

// Replaces {znamka} {model} {cena} {letnik} {km} {lokacija} with the car's data.
export function applyTemplate(template, car) {
  if (!template || !car) return template || '';
  return template
    .replace(/\{znamka\}/gi, car.znamka || '')
    .replace(/\{model\}/gi, car.model || '')
    .replace(/\{cena\}/gi, car.cena || '')
    .replace(/\{letnik\}/gi, car.letnik || '')
    .replace(/\{km\}/gi, car.mileage || '')
    .replace(/\{lokacija\}/gi, car.viewLocation || '');
}

// Parses the leading number out of a string ("12.500 €" -> 12500), or null.
export function num(s) {
  if (!s) return null;
  const n = parseInt(String(s).replace(/[^0-9]/g, ''), 10);
  return isNaN(n) ? null : n;
}

// Extracts a 4-digit Slovenian postcode from a location string, or null.
export function postcode(loc) {
  if (!loc) return null;
  const m = String(loc).match(/\b(\d{4})\b/);
  return m ? parseInt(m[1], 10) : null;
}
